import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType, Effect } from "@ngrx/effects";
import { NotificationService } from "@cradua/core";
import {
  map,
  catchError,
  concatMap,
  switchMap,
  mergeMap,
  withLatestFrom,
} from "rxjs/operators";
import { of, Observable } from "rxjs";
import * as GenericActions from "./acquisition-generic.actions";
import { AcquisitionGenericService } from "../../services/acquisition-generic.service";
import { Action, Store } from "@ngrx/store";
import { AcquisitionGenericStoreReducer, AcquisitionGenericStoreSelectors } from './index';

@Injectable()
export class AcquisitionGenericEffects {
  mainActionType: string;

  loadLandParcel$ = createEffect(() =>
    this.loadAllData(GenericActions, "LandParcel")
  );

  clearLandParcel$ = createEffect(() =>
    this.loadClearState(GenericActions, "LandParcel")
  );
  addLandParcel$ = createEffect(() => this.add(GenericActions, "LandParcel"));

  updateLandParcel$ = createEffect(() =>
    this.update(GenericActions, "LandParcel")
  );

  deleteLandParcel$ = createEffect(() =>
    this.remove(GenericActions, "LandParcel")
  );

  loadAddressBook$ = createEffect(() =>
    this.loadAllData(GenericActions, "AddressBook")
  );

  loadAddressBookWithoutId$ = createEffect(() =>
  this.loadAllDataWithoutId(GenericActions, "AddressBook")
);

  clearAddressBook$ = createEffect(() =>
  this.loadClearState(GenericActions, "AddressBook")
);

  loadAddressBookById$ = createEffect(() =>
  this.loadAllDataById(GenericActions, "AddressBook")
);

  addAddressBook$ = createEffect(() => this.add(GenericActions, "AddressBook"));

  updateAddressBook$ = createEffect(() =>
    this.update(GenericActions, "AddressBook")
  );

  deleteAddressBook$ = createEffect(() =>
    this.remove(GenericActions, "AddressBook")
  );

  loadLessorInfo$ = createEffect(() =>
    this.loadAllData(GenericActions, "LessorInfo")
  );

  loadLessorInfoById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "LessorInfo")
  );
  addLessorInfo$ = createEffect(() => this.add(GenericActions, "LessorInfo"));

  updateLessorInfo$ = createEffect(() =>
    this.update(GenericActions, "LessorInfo")
  );

  clearLessorInfo$ = createEffect(() =>
  this.loadClearState(GenericActions, "LessorInfo")
);

  deleteLessorInfo$ = createEffect(() =>
    this.remove(GenericActions, "LessorInfo")
  );


  loadLessorAreaMaker$ = createEffect(() =>
    this.loadAllData(GenericActions, "LessorAreaMaker")
  );

  loadLessorAreaMakerById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "LessorAreaMaker")
  );
  addLessorAreaMaker$ = createEffect(() => this.add(GenericActions, "LessorAreaMaker"));

  updateLessorAreaMaker$ = createEffect(() =>
    this.update(GenericActions, "LessorAreaMaker")
  );

  clearLessorAreaMaker$ = createEffect(() =>
  this.loadClearState(GenericActions, "LessorAreaMaker")
);

  deleteLessorAreaMaker$ = createEffect(() =>
    this.remove(GenericActions, "LessorAreaMaker")
  );


  loadLessorRepresentative$ = createEffect(() =>
    this.loadAllData(GenericActions, "LessorRepresentative")
  );

  loadLessorRepresentativeById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "LessorRepresentative")
  );
  addLessorRepresentative$ = createEffect(() => this.add(GenericActions, "LessorRepresentative"));

  updateLessorRepresentative$ = createEffect(() =>
    this.update(GenericActions, "LessorRepresentative")
  );

  deleteLessorRepresentative$ = createEffect(() =>
    this.remove(GenericActions, "LessorRepresentative")
  );


  clearLessorRepresentative$ = createEffect(() =>
  this.loadClearState(GenericActions, "LessorRepresentative")
);


  loadLessorStakeholder$ = createEffect(() =>
    this.loadAllData(GenericActions, "LessorStakeholder")
  );

  loadLessorStakeholderById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "LessorStakeholder")
  );
  addLessorStakeholder$ = createEffect(() => this.add(GenericActions, "LessorStakeholder"));

  updateLessorStakeholder$ = createEffect(() =>
    this.update(GenericActions, "LessorStakeholder")
  );

  deleteLessorStakeholder$ = createEffect(() =>
    this.remove(GenericActions, "LessorStakeholder")
  );


  clearLessorStakeholder$ = createEffect(() =>
  this.loadClearState(GenericActions, "LessorStakeholder")
);

  loadIndividualAcreages$ = createEffect(() =>
    this.loadAllData(GenericActions, "IndividualAcreages")
  );

  loadIndividualAcreagesById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "IndividualAcreages")
  );
  addIndividualAcreages$ = createEffect(() => this.add(GenericActions, "IndividualAcreages"));

  updateIndividualAcreages$ = createEffect(() =>
    this.update(GenericActions, "IndividualAcreages")
  );

  deleteIndividualAcreages$ = createEffect(() =>
    this.remove(GenericActions, "IndividualAcreages")
  );


  clearIndividualAcreages$ = createEffect(() =>
  this.loadClearState(GenericActions, "IndividualAcreages")
);


  loadAssetLocation$ = createEffect(() =>
    this.loadAllData(GenericActions, "AssetLocation")
  );

  loadAssetLocationById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "AssetLocation")
  );
  addAssetLocation$ = createEffect(() => this.add(GenericActions, "AssetLocation"));

  updateAssetLocation$ = createEffect(() =>
    this.update(GenericActions, "AssetLocation")
  );

  deleteAssetLocation$ = createEffect(() =>
    this.remove(GenericActions, "AssetLocation")
  );

  clearAssetLocation$ = createEffect(() =>
  this.loadClearState(GenericActions, "AssetLocation")
);

  loadCreatedUser$ = createEffect(() =>
    this.loadAllData(GenericActions, "CreatedUser")
  );

  loadCreatedUserById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "CreatedUser")
  );
  addCreatedUser$ = createEffect(() => this.add(GenericActions, "CreatedUser"));

  updateCreatedUser$ = createEffect(() =>
    this.update(GenericActions, "CreatedUser")
  );

  deleteCreatedUser$ = createEffect(() =>
    this.remove(GenericActions, "CreatedUser")
  );
  loadModifyUser$ = createEffect(() =>
    this.loadAllData(GenericActions, "ModifyUser")
  );

  loadModifyUserById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "ModifyUser")
  );
  addModifyUser$ = createEffect(() => this.add(GenericActions, "ModifyUser"));

  updateModifyUser$ = createEffect(() =>
    this.update(GenericActions, "ModifyUser")
  );

  deleteModifyUser$ = createEffect(() =>
    this.remove(GenericActions, "ModifyUser")
  );

  public SetActionType(type: string) {
    this.mainActionType = type;
  }

  protected loadClearState(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.loadGenericClearState(type)),
      mergeMap((action) => of(actions.loadGenericClearStateSuccess(type)({ returnedData: [] }))));
    return fn;



  }

  protected loadAllData(actions, type) {

    const fn: Observable<Action> = this.actions$.pipe(
        ofType(actions.loadGeneric(type)),
        concatMap((action) =>
          of(action).pipe(
            withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
          ),
        ),
        // tap(([action, data]) => console.log('data from effect ', action, data)),

        switchMap(([action, entities]) => {

          if(entities.length && entities[0].LandTitleId === action.id && action.id !== '') {
           return of(actions.loadGenericSuccess(type)({ returnedData: entities }));
          }
          return  this.acquisitionGenericService.getAll(type, action.id).pipe(
            map((data) => {
              return actions.loadGenericSuccess(type)({ returnedData: data });
            }),
            catchError((error) => of(actions.loadGenericFailure(type)({ error }))),
          )
        }),
      )
      return fn;
    }


    protected loadAllDataWithoutId(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadGenericWithoutId(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities && entities.length) {
              // console.log('data from effect ', action, entities)
             return of(actions.loadGenericWithoutIdSuccess(type)({ returnedData: entities }));
            }
            return  this.acquisitionGenericService.getAllWithoutId(type).pipe(
              map((data) => {
                return actions.loadGenericWithoutIdSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loaGenericWithoutIdFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

    protected loadAllDataById(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadByIdGeneric(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(AcquisitionGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities.length && entities[0].LandTitleId === action.id && action.id !== '') {
             return of(actions.loadByIdGenericSuccess(type)({ returnedData: entities }));
            }
            return  this.acquisitionGenericService.getAllById(type, action.id).pipe(
              map((data) => {
                return actions.loadByIdGenericSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loadByIdGenericFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

  protected add(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.addGeneric(type)),
      concatMap(({ dataToAdd }) =>
        this.acquisitionGenericService
          .createData(type, dataToAdd)
          .pipe(
            map((data) => {
              this.notification.success("Saved Successfully");
              return actions.addGenericSuccess(type)({ returnedData: data })
            }

            ),
            catchError((error) =>
              of(
                actions.addGenericFailure(type)({ error: error.error.message }),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected update(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.updateGeneric(type)),
      concatMap(({ dataToAdd, deletedData }) =>
        this.acquisitionGenericService
          .updateData(type, dataToAdd, deletedData)
          .pipe(
            map((data) => {
              this.notification.success("Updated Successfully");
              return actions.updateGenericSuccess(type)({ returnedData: data })
            }),
            catchError((error) =>
              of(
                actions.updateGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected remove(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.removeGeneric(type)),
      concatMap(({ ids }) =>
        this.acquisitionGenericService
          .deleteData(type, ids)
          .pipe(
            map((data) => {
              this.notification.success("Deleted Successfully");
              return actions.removeGenericSuccess(type)({ ids })
            }),
            catchError((error) =>
              of(
                actions.removeGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  } // loadGenericBank$ = createEffect(() =>
  // this.loadAllData(GenericActions,"Bank")
  // );
  // addGenericBank$ = createEffect(() =>
  // 	  this.add(GenericActions,"Bank")
  // );
  // updateGenericBank$ = createEffect(() =>
  // 	  this.update(GenericActions,"Bank")
  // );
  // deleteGenericBank$ = createEffect(() =>
  // 	  this.remove(GenericActions,"Bank")
  // );

  constructor(
    private actions$: Actions,
    private acquisitionGenericService: AcquisitionGenericService,
    private store: Store<AcquisitionGenericStoreReducer.GenericPartialState>,
    private notification: NotificationService,
  ) {}
}
